import {
  getRequest2,
  base,
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  postRequestForOBJ,
  uploadFileRequest,
  putRequestForJson,
  postRequestForJson,
  postRequestForJson2,
  serverAddress, postRequestForJsonByBlob,
} from './axios';

// 登陆
export const login = (params) => {
  return postRequestForJson('/xd-system-service/tbSysUser/login', params)
};
// 获取用户登录信息
export const userInfo = (params) => {
  return getRequest('/xd-system-service/tbSysUser/getInfo', params)
};
// 查询工序
export const getProcessList = (params) => {
  return getRequest('/xd-produce-service/tbProcessCategory/treeAll', params)
};
// 查询设备
export const getEquipList = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartMain/findDeptsByUserId', params)
};
export const getPage = (params) => {
  return postRequestForJson('/xd-produce-service/tbEquipBase/page', params)
};
// 切换设备
export const changeEquip = (params) => {
  return postRequest('/xd-produce-service/tbPartMain/changeEquip', params)
};
// 查询列表
export const getWaitProcessList = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartMain/list', params)
};
export const getCutPaperPasteList = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperPaste/getCutPaperPasteList', params)
};
export const getPasteFinishList = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperPasteOpt/getPasteFinishList', params)
};
export const pastePaper = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperPasteOpt/pastePaper', params)
};

export const updateCutPaperPasteOpt = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperPasteOpt/updateCutPaperPasteOpt', params)
};
export const getPageList = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperMakeupV2/getPageList', params)
};

export const getPartDeleteById = (params) => {
  return getRequest('/xd-store-service/cutPaperPasteOpt/deleteById', params)
};
export const getRecallPastePaper = (params) => {
  return getRequest('/xd-store-service/cutPaperPasteOpt/recallPastePaper', params)
};

// 查询工单详情
export const getPartNoDetail = (params) => {
  return getRequest('/xd-produce-service/tbPartMain/getOne', params)
};
// 查询可以裁切的半成品
export const getPartNoDetailTwo = (params) => {
  return getRequest('/xd-store-service/tbWholeProductSecond/findGoodsList', params)
};
export const updateGoods = (params) => {
  return getRequest('/xd-store-service/cutPaperPasteOpt/updateGoods', params)
};

export const getOptNo = (params) => {
  return getRequest('/xd-store-service/cutPaper/getOptNo', params)
};
export const getCutPaperPasteOpt = (params) => {
  return getRequest('/xd-store-service/cutPaperPasteOpt/getCutPaperPasteOpt', params)
};

//分割--保存产品添加
export const chooseCqGoods = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartGood/chooseCqGoods', params)
};
//根据物品查询序列号
export const getGoodsNoList = (params) => {
  return getRequest('/xd-store-service/store/getGoodsSourceListByTypeId', params)
};
// 保存单个
export const savePartGoodSource = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartGoodSource/save', params)
};
// 获取物料信息
export const getPrintSource = (params) => {
  return getRequest('/xd-produce-service/tbPartGoodSource/getSource', params)
};

//复合保存一级半成品
export const addFhGoods = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartGood/addFhGoods', params)
};
//复合完成
export const completeFhGoods = (params) => {
  return getRequest('/xd-produce-service/tbPartMain/completeFhGoods', params)
};
//复合查询
export const getFhGoods = (params) => {
  return getRequest('/xd-produce-service/tbPartGood/getResultListByPartNo', params)
};
//删除不需要复合的产品
export const deleteGoodsSource = (params) => {
  return getRequest('/xd-produce-service/tbPartGoodSource/deleteGoodsSource', params)
};
//复合二次提醒
export const completeTip = (params) => {
  return getRequest('/xd-produce-service/tbPartMain/completeTip', params)
};

//完成分割
export const completeFgGoods = (params) => {
  return getRequest('/xd-produce-service/tbPartMain/completeFgGoods', params)
};
export const getPasteInfo = (params) => {
  return getRequest('/xd-store-service/cutPaperPasteOpt/getPasteInfo', params)
};

//删除不需要的分割产品信息
export const deleteFgGoods = (params) => {
  return postRequest('/xd-produce-service/tbPartGood/deleteFgGoods', params)
};

//保存裁切--生产规格
export const addCqGoods = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartGood/addCqGoods', params)
};
//裁切完成
export const completeCqGoods = (params) => {
  return getRequest('/xd-produce-service/tbPartMain/completeCqGoods', params)
};

//保存裁切剩余长度
export const modyRemainCqLength = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartGood/modyRemainCqLength', params)
};
//保存分割，裁切，打包工序的打包结果
export const saveProductPackage = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartGood/saveProductPackage', params)
};

//撤销工序操作
export const revokeOrder = (params) => {
  return postRequest('/xd-produce-service/tbPartMain/revokeOrder', params)
};
//撤销打包操作
export const revokePack = (params) => {
  return postRequest('/xd-produce-service/tbPartGood/revokePack', params)
};



/**不分页查询待拼版**/
export const getPbList = (params) => {
  return getRequest('/xd-produce-service/tbPartMain/getPbList', params)
};

//查询一级半成品
export const getFirstProductList = (params) => {
  return getRequest('/xd-store-service/tbWholeProductFirst/findListForscreen', params)
};
export const getChildPackageList = (params) => {
  return getRequest('/xd-store-service/packageGoods/getChildPackageList', params)
};
export const getChildDelete = (params) => {
  return getRequest('/xd-store-service/packageGoods/delete', params)
};
export const getSliceNo = (params) => {
  return getRequest('/xd-store-service/cutPaperSliceMaterialV2/getSliceNo', params)
};
export const getPasteFinishNo = (params) => {
  return getRequest('/xd-store-service/cutPaperPasteOpt/getPasteFinishNo', params)
};

export const addPackage = (params) => {
  return postRequestForJson('/xd-store-service/packageGoods/addPackage', params)
};
export const addPack = (params) => {
  return postRequestForJson('/xd-store-service/packageGoods/pack', params)
};
export const getGoodsList = (params) => {
  return postRequestForJson('/xd-store-service/packageGoods/getGoodsList', params)
};
export const cutPaperPasteOptAdd = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperPasteOpt/add', params)
};
export const getPaperWide = (params) => {
  return postRequestForJson('/xd-store-service/makeupOptV2/getPaperWide', params)
};
export const makeupOpt = (params) => {
  return postRequestForJson('/xd-store-service/makeupOptV2/makeupOpt', params)
};
export const makeupSave = (params) => {
  return postRequestForJson('/xd-store-service/makeupOptV2/makeupSave', params)
};
export const getSplitsPage = (params) => {
  return postRequestForJson('/xd-store-service/splits/getSplitsPage', params)
};
export const getSlicePage = (params) => {
  return postRequestForJson('/xd-store-service/slice/getSlicePage', params)
};
export const getPackageLists = (params) => {
  return postRequestForJson('/xd-store-service/packageGoods/getPackageList', params)
};
export const getGoodsStockPageList = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperSliceMaterialV2/getGoodsStockPageList', params)
};
export const getGoodsStockListCC = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperSliceMaterialV2/getGoodsStockList', params)
};
export const getSlicePageList = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperSliceMaterialV2/getSlicePageList', params)
};
export const saveSliceMaterial = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperSliceMaterialV2/saveSliceMaterial', params)
};

export const getSplitsMaterialList = (params) => {
  return postRequestForJson('/xd-store-service/splitsMaterial/getSplitsMaterialList', params)
};
export const getNum = (params) => {
  return getRequest('/xd-store-service/splitsMaterial/getSplitsLength', params)
};
export const packageDecals = (params) => {
  return getRequest('/xd-store-service/cutCommon/packageDecals', params)
};

//复合
export const getNoPasteProNameList = (params) => {
  return getRequest('/xd-store-service/cutPaperPaste/getNoPasteProNameList', params)
};
//拼版
export const getNoMakeupProNameList = (params) => {
  return getRequest('/xd-store-service/cutPaperMakeupV2/getNoMakeupProNameList', params)
};
//分割
export const getNoSplitsProNameList = (params) => {
  return getRequest('/xd-store-service/splits/getNoSplitsProNameList', params)
};
//裁切
export const getNoSliceProNameList = (params) => {
  return getRequest('/xd-store-service/slice/getNoSliceProNameList', params)
};
export const getCustomerList = (params) => {
  return getRequest('/xd-store-service/splits/getCustomerList', params)
};
export const getCustomerListSlice = (params) => {
  return getRequest('/xd-store-service/slice/getCustomerList', params)
};
export const getCustomerListSplitsMaterial = (params) => {
  return getRequest('/xd-store-service/splitsMaterial/getCustomerList', params)
};
export const cutCommonDelete = (params) => {
  return getRequest('/xd-store-service/cutCommon/delete', params)
};export const cutCommonFulfill = (params) => {
  return getRequest('/xd-store-service/cutCommon/fulfill', params)
};
//打包
export const getNoPackageProNameList = (params) => {
  return getRequest('/xd-store-service/packageGoods/getNoPackageProNameList', params)
};

export const cutPaperMakeupPDF = (params) => {
  return getRequest('/xd-store-service/qrCode/cutPaperMakeupPDF/'+params.id, params)
};
export const cutPaperPDF = (params) => {
  return getRequest('/xd-store-service/qrCode/cutPaperPDF/'+params.id, params)
};
export const cutPaperSlicePDF = (params) => {
  return getRequest('/xd-store-service/qrCode/cutPaperSlicePDF/'+params.id, params)
};
export const getGoodsStockList = (params) => {
  return postRequestForJson('/xd-store-service/splitsMaterial/getGoodsStockList', params)
};
export const saveGoodsStockToSpMaterial = (params) => {
  return postRequestForJson('/xd-store-service/splitsMaterial/saveGoodsStockToSpMaterial', params)
};
export const cutCommonUpdate = (params) => {
  return postRequestForJson('/xd-store-service/cutCommon/update', params)
};

export const cutGoSlice = (params) => {
  return postRequestForJson('/xd-store-service/makeupOptV2/goSlice', params)
};
export const cutCommonDecals = (params) => {
  return postRequestForJson('/xd-store-service/cutCommon/decals', params)
};
export const decalsSplits = (params) => {
  return postRequestForJson('/xd-store-service/cutCommon/decalsSplits', params)
};
export const decalsSlice = (params) => {
  return postRequestForJson('/xd-store-service/cutCommon/decalsSlice', params)
};
export const saveGoodsslice = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperSliceMaterialV2/slice', params)
};
export const cutPaperSliceMaterialV2PmB = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperSliceMaterialV2/slice', params)
};
export const splitsGoodsStockOpt = (params) => {
  return postRequestForJson('/xd-store-service/splitsMaterial/splitsGoodsStockOpt', params)
};
export const updateHavePaperSplitsStatus = (params) => {
  return postRequestForJson('/xd-store-service/splitsMaterial/updateHavePaperSplitsStatus', params)
};
export const updateType = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperSliceMaterialV2/updateType', params)
};
export const recallMakeupSave = (params) => {
  return getRequest('/xd-store-service/makeupOptV2/recallMakeupSave', params)
};
export const deleteSelectGoodsStock = (params) => {
  return getRequest('/xd-store-service/splitsMaterial/deleteSelectGoodsStock', params)
};
export const deleteSelectGoodsStocks = (params) => {
  return getRequest('/xd-store-service/cutPaperSliceMaterialV2/deleteSelectGoodsStock', params)
};
export const getFulfillList = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperSliceMaterialV2/getFulfillList', params)
};
export const saveRemLength = (params) => {
  return postRequestForJson('/xd-store-service/splitsMaterial/saveRemLength', params)
};
export const saveRemLengths = (params) => {
  return postRequestForJson('/xd-store-service/cutPaperSliceMaterialV2/saveRemLength', params)
};
export const getMakeupInfos = (params) => {
  return postRequestForJson('/xd-store-service/makeupOptV2/getMakeupInfos', params)
};
//保存拼版结果
export const savePbResult = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartMain/savePbResult', params)
};
//计算，生产图片
export const generatePbResultImg = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartMain/generatePbResultImg', params)
};


//条件查询分类和产品
export const findProductTreeListOM = (params) => {
  return postRequest('/xd-quote-service/quoteProductCategory/findList', params)
};

//条件查询分类和产品
export const findProductTreeList = (params) => {
  return getRequest('/xd-produce-service/tbPartMain/getProductsByType', params)
};

//工序进度表、工序完成
export const getOverallList = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartMain/overall', params)
};


//保存打包
export const savePackage = (params) => {
  return postRequest('/xd-order-service/tbOrderPackage/savePackage', params)
};

//打包查询
export const getPackageList = (params) => {
  return postRequest('/xd-order-service/tbOrderPackage/queryPackageList', params)
};
//打包查询
export const queryPackageListByBatch = (params) => {
  return postRequest('/xd-order-service/tbOrderPackage/queryPackageListByBatch', params)
};
//查询打包可用的半成品信息
export const findPackageProductList = (params) => {
  return getRequest('/xd-store-service/tbWholeProduct/findPackageProductList', params)
};
//增加需要打包的物品list
export const addPackageGoods = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartGood/addPackageGoods', params)
};
//保存选择的物品list
export const savePackageGoods = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartGood/savePackageGoods', params)
};
//打包完成
export const finishPackage = (params) => {
  return getRequest('/xd-produce-service/tbPartMain/completePackage', params)
};

//打印标签稿
export const printPdf = (params) => {
  return postRequestForJson('/xd-store-service/qrCode/productPDF', params)
};
//打印复合工单
export const complexPDF = (params) => {
  return postRequestForJson('/xd-store-service/qrCode/complexPDF', params)
};
//打印分割工单
export const partingPDF = (params) => {
  return postRequestForJson('/xd-store-service/qrCode/partingPDF', params)
};
//复合工单获取打印参数
export const printFhPaper = (params) => {
  return getRequest('/xd-produce-service/tbPartMain/printFhPaper', params)
};
//新---复合工单获取打印参数
export const printNewFhPaper = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartMain/printFhPaperByPartNos', params)
};

//保存分割
export const saveCut = (params) => {
  return postRequest('/xd-produce-service/tbPartGood/addfgGoods', params)
};

//导出--打包标签
export const printPackPDF = (params) => {
  return postRequestForJson('/xd-store-service/qrCode/packPDF', params)
};

//打印分割工单
export const printFgPapers = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartMain/printFgPaper', params)
};


//打印裁切工单
export const printCqPapers = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartMain/printCqPaper', params)
};

//导出--裁切标签
export const printCutPDF = (params) => {
  return postRequestForJson('/xd-store-service/qrCode/cutPDF', params)
};

//修改工序
export const updatePartType = (params) => {
  return getRequest('/xd-produce-service/tbPartMain/modyPartType', params)
};




//查询拼版产品类型
export const getPbProducts = (params) => {
  return getRequest('/xd-produce-service/tbPartMain/getPbProducts', params)
};

//查询拼版产品
export const findListByProductId = (params) => {
  return getRequest('/xd-store-service/tbWholeProductFirst/findListByProductId', params)
};
//查询拼版指定宽度产品可用长度
export const findGoodsWidth = (params) => {
  return postRequestForJson('/xd-store-service/tbWholeBaseProduct/findGoodsWidth', params)
};
//查询拼版指定宽度产品可用长度
export const findGoodsLength = (params) => {
  return postRequestForJson('/xd-store-service/tbWholeBaseProduct/findGoodsLength', params)
};
//查询分割裁切可用的产品
export const findGoodsList = (params) => {
  return postRequestForJson('/xd-store-service/tbWholeBaseProduct/findGoodsList', params)
};

//分割--保存产品添加
export const chooseFgGoods = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartGood/chooseFgGoods', params)
};



//保存分割剩余长度
export const modyFgOriGoodsLength = (params) => {
  return postRequest('/xd-produce-service/tbPartGood/modyFgOriGoodsLength', params)
};
//保存分割实际长度
export const saveUseFgGoods = (params) => {
  return postRequestForJson('/xd-produce-service/tbPartGood/useFgGoods', params)
};
//删除分割的半成品
export const cancleFgGoods = (params) => {
  return postRequest('/xd-produce-service/tbPartGood/cancleFgGoods', params)
};
//删除裁切的半成品
export const cancleCqGoods = (params) => {
  return postRequest('/xd-produce-service/tbPartGood/cancleCqGoods', params)
};
//删除打包的产品
export const cancleDbGoods = (params) => {
  return postRequest('/xd-produce-service/tbPartGood/cancleDbGoods', params)
};



// WEBPACK FOOTER //
// ./src/api/index.js